import "#legacy/shared/components/slider.js";

Sparkle.PageBuilder.Components.ResourceCollectionAbstractBehavior = class ResourceCollectionAbstractBehavior extends (
  Sparkle.PageBuilder.Components.Behavior
) {
  // Unregistered because it is an abstract class.

  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.renderSlideshow = this.renderSlideshow.bind(this);
    this.initializeSlideshow = this.initializeSlideshow.bind(this);
    this.slideshowOptions = this.slideshowOptions.bind(this);
    this.arrowHtml = this.arrowHtml.bind(this);
    this.defaultSlideshowOptions = this.defaultSlideshowOptions.bind(this);
    this.desktopSlideshowSettings = this.desktopSlideshowSettings.bind(this);
    this.tabletSlideshowSettings = this.tabletSlideshowSettings.bind(this);
    this.mobileSlideshowSettings = this.mobileSlideshowSettings.bind(this);
    this.slideshowEnabled = this.slideshowEnabled.bind(this);
  }

  initialize() {
    if (!this.el.find(".items").children().length) {
      const anchorLinkId = this.el.find(".anchor-bar-anchor").attr("id");
      const anchor = jQuery('.anchor-bar-selector[href="#' + anchorLinkId + '"]');
      anchor.hide();
      this.el.hide();
    }

    this.navigationTop = this.el.find('[data-context-name="resource-collection-navigation-top"]');
    this.navigationBottom = this.el.find('[data-context-name="resource-collection-navigation-bottom"]');

    const collectionContainer = this.el.find("[data-component-collection-container]");
    this.carouselLabels = {
      previous: collectionContainer.data("previous-label"),
      next: collectionContainer.data("next-label"),
      region: collectionContainer.data("region-label"),
    };
    this.itemsPerRow = collectionContainer.data("items-per-row");
    this.desktopSlideshow = collectionContainer.data("component-animation") === "slideshow";
    this.mobileSlideshow = collectionContainer.data("component-animation-mobile") === "slideshow";

    this.slideshowContainer = collectionContainer.find('[data-component-plugin="slick"]');
    this.navigation = collectionContainer.append($('<div class="navigation"></div>'));

    // Arrow wrappers retain lexical `this` for the mediaCheck callbacks.
    // The constructor-level `this.renderSlideshow = this.renderSlideshow.bind(this)`
    // (a decaffeinate artifact of the original CoffeeScript `=>` binding) does
    // NOT take effect in time: the `Behavior` base class constructor calls
    // `this.initialize()` during its own `super(...args)`, which happens
    // BEFORE this class's constructor body runs its bind lines. Without the
    // arrow wrappers here, the unbound prototype method would be stored as
    // the `entry` option and later invoked with `this === options`, throwing
    // `this.slideshowEnabled is not a function`.
    if (this.mobileSlideshow) {
      new Sparkle.Responsive.mediaCheck({
        media: "(max-width:" + Sparkle.Responsive.Entities.tablet + "px)",
        entry: () => this.renderSlideshow(),
      });
    }

    if (this.desktopSlideshow) {
      return new Sparkle.Responsive.mediaCheck({
        media: "(min-width:" + Sparkle.Responsive.Entities.laptop + "px)",
        entry: () => this.renderSlideshow(),
      });
    }
  }

  // HELPER METHODS

  renderSlideshow() {
    if (this.slideshowEnabled()) {
      return;
    }
    return this.initializeSlideshow();
  }

  initializeSlideshow() {
    const options = {
      ...this.defaultSlideshowOptions(),
      ...this.slideshowOptions(),
    };

    return Sparkle.Components.Slider.initialize(this.slideshowContainer, options);
  }

  slideshowOptions() {
    return {}; // Override this method in subclasses to provide specific slideshow options
  }

  // sp-button names an icon-only button from `label`.
  arrowHtml(icon, classes, label) {
    return `<sp-button color="primary" variant="outlined" icon="${icon}" label="${label ?? ""}" class="${classes}"></sp-button>`;
  }

  defaultSlideshowOptions() {
    return {
      rows: 1,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      mobileFirst: true,
      arrows: false,
      dots: false,
      appendArrows: this.navigationTop.find(".navigation-arrows")[0] || this.slideshowContainer[0],
      prevArrow: this.arrowHtml(
        "chevron-left-filled",
        "navigation-arrows--prev slick-prev",
        this.carouselLabels.previous,
      ),
      nextArrow: this.arrowHtml("chevron-right-filled", "navigation-arrows--next slick-next", this.carouselLabels.next),
      regionLabel: this.carouselLabels.region,
      responsive: [
        {
          breakpoint: Sparkle.Responsive.Entities.laptop,
          settings: this.desktopSlideshowSettings(),
        },
        {
          breakpoint: Sparkle.Responsive.Entities.tablet,
          settings: this.tabletSlideshowSettings(),
        },
        {
          breakpoint: Sparkle.Responsive.Entities.mobile,
          settings: this.mobileSlideshowSettings(),
        },
      ],
    };
  }

  desktopSlideshowSettings() {
    if (!this.desktopSlideshow) {
      return "unslick";
    }
    return { slidesToShow: this.itemsPerRow };
  }

  tabletSlideshowSettings() {
    if (!this.mobileSlideshow) {
      return "unslick";
    }
    return { slidesToShow: Math.min(this.itemsPerRow, 2) };
  }

  mobileSlideshowSettings() {
    if (!this.mobileSlideshow) {
      return "unslick";
    }
    return { slidesToShow: 1 };
  }

  slideshowEnabled() {
    return this.slideshowContainer.hasClass("slick-initialized");
  }
};
